import React, { useEffect } from "react";
import MainSection from "./components/MainSection";

function App() {
	return (
		<>
			<MainSection></MainSection>
		</>
	);
}

export default App;
